import { selectCargoSplitsForCargo } from "../../../../ducks/data/cargos-splits-info";
import { useSelector } from "../../../../redux-store";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import CargoEventsShipment from "./CargoEventsShipment";

const CargoEventsShipmentSplits = ({ cargoId }: { cargoId: string }) => {
  const { t } = useTranslation("split");
  const cargoSplits = useSelector(selectCargoSplitsForCargo(cargoId));
  if (!cargoSplits?.length) {
    return null;
  }

  return (
    <div className="mt-8 mb-2">
      <Typography variant="h2">Cargo splits logs:</Typography>
      {cargoSplits.map((split) => (
        <div key={split.cargoId} className="mt-4">
          <div>Logs for cargo with ref: {split.ref}</div>
          {split.deleted ? (
            // Every per-cargo endpoint 404s for a deleted fragment: don't load.
            <Typography variant="body2" color="text.secondary">
              {t("fragmentDeleted")}
            </Typography>
          ) : (
            <CargoEventsShipment
              hideTitle
              createdByDispatcherId={null}
              createdAt={null}
              cargoId={split.cargoId}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default CargoEventsShipmentSplits;
